import { logGreyError } from 'owa-analytics';
import { getApplicationSettings } from 'owa-application-settings';
import type { MailboxInfo } from 'owa-client-types';

export function buildMriFromAADObjectId(
    mailboxInfo: MailboxInfo,
    aadObjectId?: string
): string | undefined {
    // MRI format doc: https://skype.visualstudio.com/SKYPECENTRAL/_wiki/wikis/SKYPECENTRAL.wiki/3055/Cloud-Specific-MRIs
    // https://eng.ms/docs/experiences-devices/m365-core/substrate-platform/substrate-identity-fabric/service-to-service-extended-auth-library/seal-docs/identity-types/mritypes
    let mriPrefix = '8:orgid';
    try {
        mriPrefix = getApplicationSettings('PresenceResource', mailboxInfo).mriPrefix;
    } catch (e) {
        logGreyError(
            'PresenceApplicationSettingError',
            mailboxInfo,
            e instanceof Error ? e : undefined
        );
    }
    return aadObjectId ? `${mriPrefix}:${aadObjectId}` : undefined;
}
